// extracted by mini-css-extract-plugin
module.exports = {"HorisontalCardsGrid":"HorisontalCardsGrid_HorisontalCardsGrid__v3UM3"};